import { Component } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
   selector: 'app-forms',
   templateUrl: './forms.component.html',
   styleUrls: ['./forms.component.css'],
   animations: [
      trigger('state', [
         state('collapse', style({ height: 0 })),
         state('expand', style({ height: '*' })),
         transition('collapse => expand', animate('300ms ease-in')),
         transition('expand => collapse', animate('400ms ease-out'))
      ])
   ]
})
export class FormsComponent {
   states = ['expand', 'expand'];

   toggle(index: number) {
      this.states[index] = this.states[index] === 'collapse' ? 'expand' : 'collapse';
   }
}
